export const CLAIM_HERO_IMAGE_ASPECT_OPTIONS = [
  {
    value: "1:1",
    cssAspectRatio: "1 / 1",
  },
  {
    value: "4:3",
    cssAspectRatio: "4 / 3",
  },
  {
    value: "16:9",
    cssAspectRatio: "16 / 9",
  },
];

const DEFAULT_CLAIM_HERO_IMAGE_ASPECT_OPTION = CLAIM_HERO_IMAGE_ASPECT_OPTIONS[0];

export function getClaimHeroImageAspectOption(value) {
  const normalized = String(value || "").trim();
  return (
    CLAIM_HERO_IMAGE_ASPECT_OPTIONS.find((option) => option.value === normalized) ||
    DEFAULT_CLAIM_HERO_IMAGE_ASPECT_OPTION
  );
}

function ratioFromDimensions(width, height) {
  const numericWidth = Math.max(0, Number(width) || 0);
  const numericHeight = Math.max(0, Number(height) || 0);
  if (!numericWidth || !numericHeight) return "";

  const aspectValue = numericWidth / numericHeight;
  if (Math.abs(aspectValue - 16 / 9) < 0.03) return "16:9";
  if (Math.abs(aspectValue - 4 / 3) < 0.03) return "4:3";
  if (Math.abs(aspectValue - 1) < 0.03) return "1:1";
  return "";
}

export function getClaimHeroImageAspectRatioCss(heroImage) {
  const explicitAspect = String(heroImage?.aspectRatio || "").trim();
  if (explicitAspect) {
    return getClaimHeroImageAspectOption(explicitAspect).cssAspectRatio;
  }

  return getClaimHeroImageAspectOption(
    ratioFromDimensions(heroImage?.width, heroImage?.height)
  ).cssAspectRatio;
}
